/*
* @AUTHOR: Mr.Huang
* @DATA: 2020/6/3 10:54 上午
*/
import Vuex from 'vuex'
import Vue from 'vue'
import state from './state'
import mutations from './mutations'
import actions from './actions'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    key: 'bin-vuex'
});

const isDev = process.env.NODE_ENV === 'development';

const store = new Vuex.Store({
    strict: isDev,
    state,
    mutations,
    actions,
    plugins: [vuexLocal.plugin]
});

if(module.hot) {
    module.hot.accept([
        './state',
        './mutations',
        './actions'
    ], () => {
        const newState = require('./state').default;
        const newMutations = require('./mutations').default;
        const newActions = require('./actions').default;
        store.hotUpdate({
            state: newState,
            mutations: newMutations,
            actions: newActions
        })
    })
}

export default store;



// WEBPACK FOOTER //
// ./src/store/Store.js